/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './style/custom.scss';

import React from 'react';
import {createRoot} from 'react-dom/client';
import AppContextProvider from "./js/components/context/appContext";
import {createBrowserRouter, RouterProvider} from 'react-router';
import {Routes} from "./js/routes";
import {getSetting} from "@dvrd/dvr-controls";

const router = createBrowserRouter(Routes, {basename: getSetting('appBaseUrl')});

const rootElement = document.getElementById('content');
if (rootElement) {
    createRoot(rootElement).render(
        <AppContextProvider>
            <RouterProvider router={router}/>
        </AppContextProvider>
    )
}